import React from 'react'
import { images } from "../../common/Images";

function OurTeam() {
  return (
    <div>
        <div className="category-details">
            <div className="description pt-5">
              <span
                className="title1"
                style={{ color: "#f71e69" }}
              >
                Our Team
              </span>
              <p
                className="pt-3 descriptions"
                style={{ fontFamily: "AvenirLTStdMedium" }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum. popularised in the 1960s with the release of
                Letraset sheets containing Lorem Ipsum passages, and more
                recently with desktop publishing software like Aldus PageMaker
                including versions of Lorem Ipsum.
              </p>
            </div>
            <div className="pt-5 row">
              <div className=" col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12">
                <img src={images.about_first} className="image1 img-fluid"></img>
              </div>

              <div className="image-des col-xxl-6 col-xl-6 col-md-6 col-12 d-flex flex-column justify-content-center">
                <span
                  className="titles"
                  style={{
                    color: "#f71e69",
                   
                    fontFamily: "AvenirLTStdMedium",
                  }}
                >
                  Lorem Ipsum
                </span>
                <p
                  className="descriptions"
                  style={{ fontFamily: "AvenirLTStdMedium" }}
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                  popularised in the 1960s with the release of Letraset sheets
                  containing Lorem Ipsum passages, and more recently with
                  desktop publishing software like Aldus PageMaker including
                  versions of Lorem Ipsum.
                </p>
              </div>
            </div>
            <div className="pt-1 row">
              <div className="image-des col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column justify-content-center">
                <span
                  className="titles"
                  style={{
                    color: "#f71e69",
                    fontFamily: "AvenirLTStdMedium",
                  }}
                >
                  Lorem Ipsum
                </span>
                <p
                  className="descriptions"
                  style={{ fontFamily: "AvenirLTStdMedium" }}
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum.
                  popularised in the 1960s with the release of Letraset sheets
                  containing Lorem Ipsum passages, and more recently with
                  desktop publishing software like Aldus PageMaker including
                  versions of Lorem Ipsum.
                </p>
              </div>
              <div className="col-xxl-6 col-xl-6 col-md-6 col-12">
                <img src={images.about_second} className="image1 img-fluid"></img>
              </div>
            </div>
          </div>
    </div>
  )
}

export default OurTeam